import { colors } from '@/constants/colors';
import { useUIStore } from '@/store/useUIStore';
import { SelectOption } from '@/types/shared';
import IconsLib from '@/utils/IconsLib';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import ImageUI from './ImageUI';
import { IconType } from '@/utils/icons';

interface Props {
   title: string;
   data: SelectOption[];
   onChange: (item: SelectOption) => void;
   // key?: string | number;
   srcIconDefault?: IconType;
   error?: boolean;
}

const Select = ({
   title,
   data,
   onChange,
   // key,
   srcIconDefault,
   error,
}: Props) => {
   const [selected, setSelected] = useState<SelectOption | null>(null);
   const { outsideClickId } = useUIStore();

   // console.log(`data`, data);
   // Update selected when data changes and no item is selected yet
   useEffect(() => {
      // console.log(data && data.length > 0 && !selected);
      if (data && data.length > 0 && !selected) {
         // console.log(data[0]);
         setSelected(data[0]);
      }
   }, [data, selected]);

   const handleSelect = (item: SelectOption) => {
      setSelected(item);
      onChange(item);
   };

   // Reset selected when data changes
   // useEffect(() => {
   //    setSelected(null);
   // }, [data]);
   // console.log(`selected`, data);
   // console.log(`selected---`, selected);

   // console.log(`title---`, title);

   // Ensure data is valid before rendering
   if (!data || data.length === 0) {
      return (
         <Wrapper>
            <Title>{title}</Title>
            <SelectBtn id="select-dropdown" $isOpen={false}>
               <SelectLabel id="select-dropdown">
                  No options available
               </SelectLabel>
               <IconsLib
                  icon={srcIconDefault ?? 'arrow-down-s-fill'}
                  size="20px"
                  color={colors.GRAY4}
                  id="select-dropdown"
               />
            </SelectBtn>
         </Wrapper>
      );
   }

   return (
      <Wrapper>
         <Title>{title}</Title>
         <SelectBtn
            id="select-dropdown"
            $isOpen={outsideClickId === 'select-dropdown'}
         >
            <SelectMain>
               {selected?.srcIcon ? (
                  <ImageUI
                     src={selected?.srcIcon || ''}
                     alt={selected?.name || ''}
                     width="20px"
                     height="20px"
                  />
               ) : (
                  <IconsLib
                     icon={srcIconDefault || 'bank-line'}
                     size="20px"
                     color={colors.GRAY1}
                  />
               )}

               <SelectLabel id="select-dropdown">
                  {selected ? selected.name : 'Select an option'}
               </SelectLabel>
            </SelectMain>
            <IconsLib
               icon="arrow-down-s-fill"
               size="20px"
               color={colors.GRAY4}
               id="select-dropdown"
            />
         </SelectBtn>
         {error && (
            <ErrorWrapper>
               <IconsLib
                  icon="error-warning-fill"
                  size="15px"
                  color={colors.DANGER}
               />
               <LabelRequired>{title} is required</LabelRequired>
            </ErrorWrapper>
         )}
         {data.length > 0 && outsideClickId === 'select-dropdown' && (
            <List $hasTitle={title !== ''}>
               {data.map((item, index) => (
                  <Item
                     key={item._id || index}
                     onClick={() => handleSelect(item)}
                  >
                     {item.srcIcon ? (
                        <ImageUI
                           src={item.srcIcon || ''}
                           alt={item.name}
                           width="20px"
                           height="20px"
                        />
                     ) : (
                        <IconsLib
                           icon={srcIconDefault || 'bank-line'}
                           size="20px"
                           color={colors.GRAY1}
                        />
                     )}

                     <ItemLabel> {item.name}</ItemLabel>
                  </Item>
               ))}
            </List>
         )}
      </Wrapper>
   );
};

const Wrapper = styled.div`
   /* min-width: 200px; */
   width: 100%;
   /* margin-top: 1rem; */
   position: relative;
`;

const Title = styled.p`
   font-size: 15px;
   color: ${colors.GRAY2};
`;

const SelectBtn = styled.div<{ $isOpen: boolean }>`
   margin-top: 5px;
   display: flex;
   justify-content: space-between;
   align-items: center;
   border: 1px solid
      ${({ $isOpen }) => ($isOpen ? colors.PRIMARY : colors.GRAY12)};
   padding: 5px 1rem;
   border-radius: 4px;
   user-select: none;
   cursor: pointer;
   transition: border-color 0.2s ease, box-shadow 0.2s ease;

   ${({ $isOpen }) =>
      $isOpen &&
      `
      box-shadow: 0 0 0 1px ${colors.PRIMARY};
   `}
`;

const SelectMain = styled.div`
   display: flex;
   align-items: center;
   gap: 10px;
`;

const SelectLabel = styled.p`
   font-size: 15px;
   color: ${colors.GRAY1};
`;
const List = styled.div<{ $hasTitle: boolean }>`
   position: absolute;
   top: ${({ $hasTitle }) => ($hasTitle ? '3.9rem' : '2.5rem')};
   left: 0;
   width: 100%;
   background-color: var(--app-surface);
   max-height: 150px;
   overflow-y: scroll;
   box-shadow: ${colors.BOXSHADOW};
   z-index: 12;

   /* width */
   &::-webkit-scrollbar {
      width: 7px;
      height: 7px;
   }

   /* Track */
   &::-webkit-scrollbar-track {
      // box-shadow: inset 0 0 5px grey;
      border-radius: 10px;
   }

   /* Handle */
   &::-webkit-scrollbar-thumb {
      background: ${colors.GRAY11};
      border-radius: 10px;
   }

   /* Handle on hover */
   &::-webkit-scrollbar-thumb:hover {
      background: ${colors.GRAY10};
   }
`;

const Item = styled.div`
   display: flex;
   align-items: center;
   gap: 10px;
   padding: 3px 1rem;
   font-size: 15px;
   color: ${colors.GRAY1};
   cursor: pointer;
   &:hover {
      background-color: ${colors.GRAY14};
   }
`;

const ItemLabel = styled.p`
   font-size: 14px;
   color: ${colors.GRAY1};
`;

const ErrorWrapper = styled.div`
   display: flex;
   justify-content: flex-start;
   align-items: center;
   gap: 5px;
`;

const LabelRequired = styled.p`
   /* padding-top: 5px; */
   color: ${colors.DANGER};
   font-size: 14px;
`;

export default Select;
